import type { OnboardingStep } from './onboarding-step';

// Phases are listed in execution order so the source mirrors the actual
// wizard timeline. The progress bar in `OnboardingProgress.tsx` and the
// step-kind → phase mapping in `progressPhaseFor` below must agree with
// this ordering for the progress indicator to advance monotonically.
export type OnboardingProgressPhase =
  | 'invite'
  | 'application'
  | 'credentialing'
  | 'profile'
  | 'details'
  | 'legal'
  | 'disclaimer'
  | 'demographics'
  | 'verify'
  | 'code'
  | 'bank'
  | 'complete';

export function progressPhaseFor(step: OnboardingStep): OnboardingProgressPhase {
  switch (step.kind) {
    case 'consuming_invite':
    case 'invite_failed':
      return 'invite';

    case 'loading':
    case 'fetch_error':
    case 'submit_application':
    case 'application_pending':
    case 'application_rejected':
      return 'application';

    case 'fill_credentialing_form':
    case 'credentialing_pending':
      return 'credentialing';

    case 'fill_employee_record':
      return 'profile';

    case 'enter_prescriber_details':
    case 'start_idp':
    case 'awaiting_dosespot':
      return 'details';

    case 'sign_legal_agreements':
      return 'legal';

    case 'sign_disclaimer':
      return 'disclaimer';

    case 'submit_demographics':
      return 'demographics';

    case 'answer_questions':
      return 'verify';

    case 'submit_otp':
      return 'code';

    case 'link_bank_account':
      return 'bank';

    case 'complete':
      return 'complete';

    default: {
      const _exhaustive: never = step;
      void _exhaustive;
      return 'complete';
    }
  }
}
